import React from 'react'

import {
  Profile,
  LoadingStates,
  TestResultsProfile,
} from '@dashboard/lib/types'
import CrystalInfo from '../CrystalInfo'
import CelebInfo from '../CelebInfo'

import css from './styles.module.scss'

interface OwnProps {
  profile?: Profile | TestResultsProfile | null
  signUpCTAText?: string
  signUpCTALink?: string
  otherCelebritiesResult?: Profile[]
  otherCelebritiesState?: LoadingStates
  customModules?: JSX.Element
  hideCrystalInfo?: boolean
}
interface State {}

export default class SideBar extends React.Component<OwnProps, State> {
  render() {
    const { customModules } = this.props

    return (
      <div className={css.noPrint}>
        {this.renderCelebInfo()}
        {customModules || null}
      </div>
    )
  }

  renderCelebInfo() {
    const {
      profile,
      signUpCTAText,
      signUpCTALink,
      otherCelebritiesResult,
      otherCelebritiesState,
      hideCrystalInfo,
    } = this.props

    if (hideCrystalInfo) return null

    if (profile && profile.personality) {
      return (
        <CelebInfo
          profile={profile}
          otherCelebritiesResult={otherCelebritiesResult}
          otherCelebritiesState={otherCelebritiesState}
        />
      )
    }

    return <CrystalInfo buttonText={signUpCTAText} buttonHREF={signUpCTALink} />
  }
}
